"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SummaryBox_1 = __importDefault(require("./SummaryBox"));
exports.default = SummaryBox_1.default;
